import * as React from "react";

function SvgIcChevronUp(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.707 15.707a1 1 0 000-1.414L13.414 7a2 2 0 00-2.828 0l-7.293 7.293a1 1 0 101.414 1.414L12 8.414l7.293 7.293a1 1 0 001.414 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcChevronUp;
